export default function setUserTokens(idToken, accessToken) {
  localStorage.setItem("Hstm.Identity.AccessToken", accessToken);
  localStorage.setItem("Hstm.Identity.IdentityToken", idToken);
}
